<template>
  <div class="frisbuy-emoji">
    <div
      v-for="(emoji, index) in interaction.emojis"
      class="frisbuy-emoji__wrapper"
      :class="{
        'frisbuy-emoji__wrapper--selected': emoji.isSelected,
        'frisbuy-emoji__wrapper--disabled': isAlreadySelected,
      }"
      @click="() => clickEmoji(emoji, index)"
      :key="index"
      :style="emojiStyles"
    >
      <img
        :src="getDomainSubstitute(emoji.url)"
        :alt="emoji.name"
        @error="errorImageHandler"
      />
      <div class="frisbuy-emoji__background"></div>
      <div
        class="frisbuy-emoji__pop"
        v-if="index == interaction.emojis.length - 1"
      ></div>
    </div>
  </div>
</template>

<script>
// Services
import { MediaCatcher } from "@/common/services/ErrorHandler/ErrorCatcher";
import { DomainSubstitute } from "@/common/services/DomainSubstitute/DomainSubstitute";
// Consts
import widgetTypes from "@/common/consts/widgetTypes";

export default {
  props: ["interaction"],

  emits: ["clickEmoji"],

  data() {
    return {
      isAlreadySelected: false,
    };
  },

  mounted() {
    this.checkOnSelectedEmoji();
  },

  watch: {
    interaction: {
      handler() {
        this.checkOnSelectedEmoji();
      },
      deep: true,
    },
  },

  computed: {
    emojiStyles() {
      return {
        width: `calc(var(--frisbuy-interaction-width) * ${
          100 - (this.interaction.emojis.length - 1) * 10
        } * 1px)`,
        padding: `calc(var(--frisbuy-interaction-width) * ${
          20 - (this.interaction.emojis.length - 1) * 2
        } * 1px)`,
      };
    },
  },

  methods: {
    clickEmoji(emoji, index) {
      if (!this.isAlreadySelected) {
        this.$emit("clickEmoji", { ...emoji, emojiIndex: index });
      }
    },

    checkOnSelectedEmoji() {
      const selectedEmoji = this.interaction.emojis.find((emoji) => {
        return emoji.isSelected;
      });

      this.isAlreadySelected = selectedEmoji !== undefined;
    },

    getDomainSubstitute(srcUrl) {
      return DomainSubstitute(srcUrl);
    },

    errorImageHandler(e) {
      MediaCatcher(e, 2, widgetTypes.STORY);
    },
  },
};
</script>

<style lang="scss">
.frisbuy-emoji {
  display: flex;
  gap: 8px;

  &,
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  .frisbuy-emoji__wrapper {
    position: relative;

    border-radius: 50%;
    cursor: pointer;

    aspect-ratio: 1 / 1;
    z-index: 0;

    &:hover {
      .frisbuy-emoji__background {
        background-color: #dadada;
      }
    }

    &--selected {
      & > .frisbuy-emoji__background {
        background-color: #dfdfdf !important;
      }
    }

    &--disabled {
      cursor: not-allowed;

      &:hover {
        .frisbuy-emoji__background {
          background-color: #fff;
        }
      }
    }

    img {
      display: block;
      width: 100%;
    }

    .frisbuy-emoji__background {
      position: absolute;
      inset: 0;

      width: inherit;
      height: inherit;

      border-radius: 50%;
      background-color: #fff;
      z-index: -1;
      filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
    }

    .frisbuy-emoji__pop {
      position: absolute;
      right: 4%;
      bottom: 4%;

      width: calc(var(--frisbuy-interaction-width) * 30 * 1px);
      aspect-ratio: 1 / 1;

      transform: skew(0, 4deg);

      border-radius: 0 0 7px 0;
      background-color: #fff;

      filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));

      z-index: -2;
    }
  }
}
</style>
